// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as IncidentalChargeApiModel from "../api-model/IncidentalChargeApiModel.bs.js";

function apiModelToState(res) {
  return {
          incidental_charge_types: List.map((function (incidental_type) {
                  return {
                          id: incidental_type.id,
                          name: incidental_type.name
                        };
                }), res.data.incidental_charge_types)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(IncidentalChargeApiModel.t_decode(json), "IncidentalChargeEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
